import React from "react";

import { DistributorsDataProvider } from "../../../common/data/lookup-data-providers/DistributorsDataProvider";
import { OrderAirlinesDataProvider } from "../../common/data-providers/OrderAirlinesDataProvider";
import { OrderListingProvider } from "./context/OrderListingProvider";
import { OrderListing } from "./OrderListing";

export const OrderListingDashboard: React.VFC = () => {
    return (
        <OrderAirlinesDataProvider>
            <OrderListingProvider>
                <DistributorsDataProvider>
                    <OrderListing />
                </DistributorsDataProvider>
            </OrderListingProvider>
        </OrderAirlinesDataProvider>
    );
};
